import { Component } from '@angular/core';
import { AlertModule } from '@coreui/angular';
import { INoRowsOverlayAngularComp } from 'ag-grid-angular';
import { INoRowsOverlayParams } from 'ag-grid-community';
import { ALERT_TYPES } from '../../constants/ag-grid.constant';
@Component({
  selector: 'smarsh-custom-no-rows-overlay',
  standalone: true,
  imports: [AlertModule],
  template: `<c-alert
    color="{{ alertType }}"
    class="bg-{{ alertType }}-subtle text-{{ alertType }}-emphasis m-0">
    {{ noRowsMessage }}
  </c-alert>`
})
export class CustomNoRowsOverlayComponent implements INoRowsOverlayAngularComp {
  noRowsMessage: string;
  alertType: string;

  getAlertType(alertType: string) {
    switch (alertType) {
      case ALERT_TYPES.INFO:
        return ALERT_TYPES.INFO;
      default:
        return ALERT_TYPES.DANGER;
    }
  }

  agInit(params: INoRowsOverlayParams): void {
    this.noRowsMessage = params['noRowsMessage'];
    this.alertType = this.getAlertType(params['alertType']);
  }

  refresh(params: INoRowsOverlayParams): void {
    this.noRowsMessage = params['noRowsMessage'];
    this.alertType = this.getAlertType(params['alertType']);
  }
}
